export const DATE_FORMAT = 'dd.MM.yyyy';
export const DATE_FORMAT__SHORT_YEAR = 'dd.MM.yy';
export const TIME_FORMAT = 'HH:mm';
export const DATETIME_FORMAT = 'dd.MM.yyyy HH:mm';
export const DATETIME_FORMAT_WITH_SECONDS = 'dd.MM.yyyy HH:mm:ss';
